import {React, useEffect, useState} from 'react'
import {TextElement, TextHighlight, ContentContainer, Input, Label, InputContainer, ChartContainer, RowForm} from './GraniceElements'
import {Line} from "react-chartjs-2";
import {InputLimitAndEmptyValueHandling} from "../../scripts/InputHandling";

const Granice = () => {
    const [inputs, setInputs] = useState({StartN: 2, MaxEnv: 1000, Birth: 0.6, Death: 0.4});
    const [Time, setTime] = useState([]);
    const [Value, setValue] = useState([]);
    const InputsLimit = [
        {
            InputName: "StartN",
            LimitMax: null,
            LimitMin: 2,
            default: 2
        },
        {
            InputName: "MaxEnv",
            LimitMax: 1e+30,
            LimitMin: 10,
            default: 1000
        },
        {
            InputName: "Birth",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.6
        },
        {
            InputName: "Death",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.4
        }];

    const handleOutFocus = (e) => {
        if(e.target.name === 'MaxEnv' && e.target.value<inputs.StartN){
            e.target.value = inputs.StartN+10;
        }else if(e.target.name === 'StartN' && e.target.value>inputs.MaxEnv){
            e.target.value = inputs.MaxEnv-10;
        }
        const properValue = InputLimitAndEmptyValueHandling(InputsLimit, e);
        setInputs({...inputs, [e.target.name]: properValue});
        e.target.value = properValue;
    }

    const logistic = (N,K,b,d,t) => {
        const r = b-d;
        let i = 0;
        let y = 0;
        const out = [];
        let prevY = 0;
        let Nt = 0;
        let end = false;
        while(i < t) {
            Nt = (N*K)/((K-N)*(Math.E**(-r*i))+N);
            if(Number.isInteger(i)){
                y = Math.round(Nt)
            }else{
                y = Nt
            }
            out.push({
                day: i,
                y: y
            });
            if(y===prevY && end === false){
                t = i+5;
                end = true;
            }
            if(end === true && y!==prevY){
                end = false;
                t = 500;
            }
            prevY = y;
            i += 1;
        }
        return out;
    }

    useEffect(() => {
        const sim = logistic(inputs.StartN, inputs.MaxEnv, inputs.Birth, inputs.Death, 500);
        setTime(sim.map(s => s.day));
        setValue(sim.map(s => s.y));
    }, [inputs])

    let data = {
        labels: Array.from(Time, (value, index) => (value===0) ? "Punkt startowy" : "Dzień "+value),  // Etykiety osi X
        datasets: [
            {
                label: 'Y',  // Legenda
                data: Value,  // Dane osi Y
                borderColor: 'rgba(75, 192, 192, 1)',  // Kolor linii
                backgroundColor: 'rgba(75, 192, 192, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
        ],
    };

    // Opcje wykresu (opcjonalne)
    const options = {
        responsive: true,  // Responsywność
        plugins: {
            legend: {
                display: false,
            },
        },
    };

    return (
        <>
            <ContentContainer>
                <InputContainer>
                    <RowForm>
                        <Label htmlFor="StartN-input">Wprowadź liczbę początkową osobników:</Label>
                        <Input id="StartN-input" name="StartN" type="number" defaultValue={inputs.StartN} onBlur={handleOutFocus} min="2"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="MaxEnv-input">Wprowadź pojemność środowiska:</Label>
                        <Input id="MaxEnv-input" name="MaxEnv" type="number" defaultValue={inputs.MaxEnv} onBlur={handleOutFocus} min="3"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Birth-input">Wprowadź współczynnik urodzin:</Label>
                        <Input id="Birth-input" name="Birth" type="number" defaultValue={inputs.Birth} onBlur={handleOutFocus} min="0" max="1" step={0.01}/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Death-input">Wprowadź współczynnik śmierci:</Label>
                        <Input id="Death-input" name="Death" type="number" defaultValue={inputs.Death} onBlur={handleOutFocus} min="0" max="1" step={0.01}/>
                    </RowForm>
                </InputContainer>
                <ChartContainer>
                    <Line data={data} options={options} />
                </ChartContainer>
            </ContentContainer>
        </>
    )
}

export default Granice
